module.exports = __webpack_public_path__ + "static/media/highdifelity2.347a9da7.webp";